import React, { PureComponent, ReactNode } from 'react';
import { CreateServiceInstant } from '.';
import { i18n } from "../../../../../configuration/i18n";
import { DefaultPageHeader } from "../../../../../common/adapters/primaries/defaultPage.header";

interface Props {
    onCreate: () => void
}

export class CreateServiceInstantPage extends PureComponent<Props> {
    render(): ReactNode {
        return (
            <div>
                <DefaultPageHeader title={i18n.management_instant.add_service}/>

                <CreateServiceInstant onCreate={() => window.location.href = '/instants'}/>
            </div>
        )
    }
}
